import jwtDecode from 'jwt-decode';
import { authService } from '@/plugins/vue-auth.ts';

const normalizeAuth0UserId = (raw?: string | null): string | undefined => {
    if (!raw) return undefined;
    const parts = raw.split('|');
    if (parts.length === 2) return parts[1]; // auth0|123
    if (parts.length === 3) return parts[1]; // auth0|123|env
    return raw;
};

const decodeTokenUserId = (token?: string | null): string | undefined => {
    if (!token) return undefined;
    try {
        const decoded: { sub?: string; user_id?: string } = jwtDecode(token);
        const rawId = decoded.user_id || decoded.sub || undefined;
        return normalizeAuth0UserId(rawId);
    } catch {
        return undefined;
    }
};

export const readAuthContextAttributes = (
    authInstance: any = authService
): Record<string, unknown> => {
    try {
        const auth = authInstance;
        if (!auth) return {};

        const impersonatingRaw =
            typeof auth.impersonating === 'function'
                ? auth.impersonating()
                : auth?.data?.impersonating;
        const impersonating =
            impersonatingRaw === undefined ? undefined : Boolean(impersonatingRaw);

        const attributes: Record<string, unknown> = {};
        if (impersonating !== undefined) {
            attributes.impersonating = impersonating;
        }

        const user = typeof auth.user === 'function' ? auth.user() : auth?.data?.user;
        const impersonatedUserId = user?.id;

        if (impersonating !== true) {
            if (impersonatedUserId) {
                attributes.loggedInUserId = String(impersonatedUserId);
            }
            return attributes;
        }

        // impersonating === true
        if (impersonatedUserId) {
            attributes.impersonatedUserId = String(impersonatedUserId);
        }

        const unmaskedToken =
            typeof auth.unmaskedToken === 'function'
                ? auth.unmaskedToken()
                : auth?.data?.unmaskedToken;
        const originalAccessToken = auth?.data?.accessToken;
        const realUserId =
            decodeTokenUserId(unmaskedToken) || decodeTokenUserId(originalAccessToken);

        if (realUserId) {
            attributes.loggedInUserId = String(realUserId);
        }

        return attributes;
    } catch {
        return {};
    }
};

export default readAuthContextAttributes;
